module.exports = __webpack_public_path__ + "assets/img/TRYPEN.webp?0bdddfa4591d3a2539888b25aa6af8ed";